import api from "./api";

class ClientiManager {
    clienti(config?: any) {
        return api.get(`/clienti`, config);
    }

    search(config?: any) {
        return api.get(`/clienti/search`, config);
    }

    clienteCreate(data: any) {
        return api.post(`/clienti`, data);
    }

    clienteUpdate(cliente_id: number | string, data: any) {
        return api.put(`/clienti/${cliente_id}`, data);
    }

    cliente(cliente_id: number | string | undefined, config?: any) {
        return api.get(`/clienti/${cliente_id}`, config);
    }

    terminiBusinessUnits(
        cliente_id: number | string | undefined,
        config?: any
    ) {
        return api.get(`/clienti/${cliente_id}/termini`, config);
    }

    createTermini(cliente_id: number | string | undefined, data: any) {
        return api.post(`/clienti/${cliente_id}/termini`, data);
    }
    alertCrate(cliente_id: number | string | undefined, data: any) {
        return api.post(`/clienti/${cliente_id}/alerts`, data);
    }

    alertAutomaticoToggle(cliente_id: number | string) {
        return api.put(`/clienti/${cliente_id}/toggle`);
    }

    delete(cliente_id: number | string | undefined) {
        return api.delete(`/clienti/${cliente_id}`);
    }

    settoriCommericali(cliente_id: number | string | undefined, config?: any) {
        return api.get(`/clienti/${cliente_id}/settori`, config);
    }

    attivita(cliente_id: number | string | undefined, config?: any) {
        return api.get(`/clienti/${cliente_id}/attivita`, config);
    }

    attivitaCrate(cliente_id: number | string | undefined, data: any) {
        return api.post(`/clienti/${cliente_id}/attivita`, data);
    }

    contattiAzienda(cliente_id: number | string | undefined, config?: any) {
        return api.get(`/clienti/${cliente_id}/contatti`, config);
    }

    presentazioniAzienda(
        cliente_id: number | string | undefined,
        config?: any
    ) {
        return api.get(`/clienti/${cliente_id}/presentazioni`, config);
    }

    accountsAzienda(cliente_id: number | string | undefined, config?: any) {
        return api.get(`/clienti/${cliente_id}/accounts`, config);
    }

    approvazione(cliente_id: number | string | undefined, approvata: boolean) {
        return api.post(`/clienti/${cliente_id}/approvazione`, {
            approvata: approvata,
        });
    }

    sottoprogetti(cliente_id: number | string, config?: any) {
        return api.get(`/clienti/${cliente_id}/sottoprogetti`, config);
    }

    storico(cliente_id: number | string, config?: any) {
        return api.get(`/clienti/${cliente_id}/storico/`, config);
    }

    export(config?: any) {
        return api.get(`/clienti/export`, config);
    }

    retrieve = this.cliente;
    list = this.clienti;
    paginatedList = this.clienti;
}

const clientiManager = new ClientiManager();

export default clientiManager;
